import cn from 'clsx'
import logo from '../../pages/home/xeno.png'
import NextImage from 'next/image'
import s from './image.module.scss'

export function Image({ className, ...props }) {
  return <NextImage src={logo} {...props} className={cn(s.image, className)} />
}
